import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useBranding } from '../../theme/brandingContext';

const ConfirmationPage = () => {
  const location = useLocation();
  const { branding } = useBranding();
  const applicationNumber = location.state?.applicationNumber;

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, md: 8 } }}>
      <Card>
        <CardContent sx={{ p: { xs: 3, md: 4 }, textAlign: 'center' }}>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 56, mb: 1.5 }} />
          <Typography variant="h2" component="h1" sx={{ mb: 1 }}>
            Application submitted
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Thank you for applying with {branding?.companyName || 'us'}.
            A loan officer will follow up shortly.
          </Typography>

          {applicationNumber && (
            <Box
              sx={{
                bgcolor: 'action.hover',
                borderRadius: 2,
                px: 2,
                py: 1.5,
                mb: 3,
              }}
            >
              <Typography variant="caption" color="text.secondary" display="block">
                Application number
              </Typography>
              <Typography variant="h3" component="p" sx={{ fontFamily: 'monospace' }}>
                {applicationNumber}
              </Typography>
            </Box>
          )}

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
            <Button component={RouterLink} to="/status" variant="contained" color="primary">
              Check loan status
            </Button>
            <Button component={RouterLink} to="/" variant="outlined" color="inherit">
              Back to home
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ConfirmationPage;
